import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { DATA, PER_PAGE } from '@/plugins/vuex-async-pagginate';

class ContactExternalNumberClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getSelect(params = {}) {
    return this.getList({ ...params, [PER_PAGE]: 500 }).then(res => res[DATA]);
  }
}

export const ContactExternalNumber = new ContactExternalNumberClass({
  api_version: 2,
  resource: 'pbx/contact-external-numbers'
});
